//frontend/src/components/AdminRequests/Chat/components/ChatHeader.jsx

import React from "react";

export default function ChatHeader({ roomId, onClose }) {
  return (
    <div className="chat-header">
      <div>
        <strong>Чат с администратором</strong>
        <span>Matrix{roomId ? ` · ${roomId.slice(0, 8)}…` : ""}</span>
      </div>
      <button type="button" className="chat-header__close" onClick={onClose}>
        ×
      </button>
    </div>
  );
}